import React, { useState } from 'react';

const InfoSection = () => {
  const [activeTab, setActiveTab] = useState('about');
  const [openFaq, setOpenFaq] = useState(null);

  const faqItems = [
    {
      question: "Wie funktioniert der Lottozahlen Generator?",
      answer: "Unser Generator verwendet einen kryptographisch sicheren Zufallszahlengenerator, um völlig zufällige Zahlen zwischen 1 und 49 zu erzeugen. Jede Zahl hat die gleiche Wahrscheinlichkeit, gezogen zu werden."
    },
    {
      question: "Sind die generierten Zahlen wirklich zufällig?",
      answer: "Ja, alle Zahlen werden mit einem echten Zufallszahlengenerator erstellt. Es gibt keine Muster oder Vorhersagbarkeit. Jede Kombination ist gleich wahrscheinlich."
    },
    {
      question: "Kann ich die gleichen Zahlen mehrfach generieren?",
      answer: "Theoretisch ja, aber die Wahrscheinlichkeit ist sehr gering. Da es 13.983.816 mögliche Kombinationen gibt, ist es unwahrscheinlich, dass Sie zweimal die gleichen Zahlen erhalten."
    },
    {
      question: "Was ist die Superzahl?",
      answer: "Die Superzahl ist eine zusätzliche Zahl von 0 bis 9, die bei der deutschen Lottoziehung verwendet wird. Sie erhöht Ihre Gewinnchancen in bestimmten Gewinnklassen."
    },
    {
      question: "Kosten die generierten Zahlen etwas?",
      answer: "Nein, unser Lottozahlen Generator ist vollständig kostenlos und ohne Registrierung nutzbar."
    },
    {
      question: "Kann ich meine Glückszahlen speichern?",
      answer: "Ja, der Generator speichert automatisch Ihre letzten generierten Zahlen im Browser. Sie können diese jederzeit im Verlauf einsehen."
    }
  ];

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <div>
      <ul className="nav nav-tabs nav-justified mb-4" role="tablist">
        <li className="nav-item" role="presentation">
          <button
            className={`nav-link ${activeTab === 'about' ? 'active' : ''}`}
            onClick={() => setActiveTab('about')}
            type="button"
          >
            Über uns
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className={`nav-link ${activeTab === 'how-it-works' ? 'active' : ''}`}
            onClick={() => setActiveTab('how-it-works')}
            type="button"
          >
            Wie es funktioniert
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className={`nav-link ${activeTab === 'tips' ? 'active' : ''}`}
            onClick={() => setActiveTab('tips')}
            type="button"
          >
            Tipps
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className={`nav-link ${activeTab === 'faq' ? 'active' : ''}`}
            onClick={() => setActiveTab('faq')}
            type="button"
          >
            FAQ
          </button>
        </li>
      </ul>

      <div className="card bg-light bg-opacity-10 border-0">
        <div className="card-body">
          {activeTab === 'about' && (
            <div>
              <h5 className="card-title text-white mb-3">Über den Lottozahlen Generator</h5>
              <p className="text-white-50">
                Unser kostenloser Lottozahlen Generator hilft Ihnen dabei, zufällige Zahlen für das deutsche Lotto "6 aus 49" zu generieren. 
                Wir verwenden einen sicheren Zufallszahlengenerator, um sicherzustellen, dass jede Zahl die gleiche Wahrscheinlichkeit hat, gezogen zu werden.
              </p>
              <p className="text-white-50">
                Der Generator ist vollständig kostenlos, erfordert keine Registrierung und respektiert Ihre Privatsphäre. 
                Alle Berechnungen erfolgen lokal in Ihrem Browser.
              </p>
              <h6 className="text-white mt-4 mb-3">Warum unseren Generator verwenden?</h6>
              <ul className="text-white-50">
                <li>✓ Völlig kostenlos und ohne Werbung</li>
                <li>✓ Fairer und zufälliger Algorithmus</li>
                <li>✓ Keine Registrierung erforderlich</li>
                <li>✓ Funktioniert auf allen Geräten</li>
                <li>✓ Speichert Ihre Zahlen automatisch</li>
              </ul>
            </div>
          )}

          {activeTab === 'how-it-works' && (
            <div>
              <h5 className="card-title text-white mb-3">Wie funktioniert der Generator?</h5>
              <ol className="text-white-50">
                <li className="mb-2">
                  <strong>Zufallszahlengenerator:</strong> Unser System verwendet den JavaScript Math.random() Algorithmus, 
                  der kryptographisch sicher ist und echte Zufallszahlen erzeugt.
                </li>
                <li className="mb-2">
                  <strong>Zahlenauswahl:</strong> Es werden 6 eindeutige Zahlen zwischen 1 und 49 zufällig ausgewählt.
                </li>
                <li className="mb-2">
                  <strong>Sortierung:</strong> Die Zahlen werden automatisch in aufsteigender Reihenfolge sortiert, 
                  wie es beim deutschen Lotto üblich ist.
                </li>
                <li className="mb-2">
                  <strong>Superzahl:</strong> Zusätzlich wird eine Superzahl zwischen 0 und 9 generiert.
                </li>
              </ol>
              <p className="text-white-50 mt-3">
                <strong>Wichtig:</strong> Jede Kombination von 6 Zahlen hat exakt die gleiche Wahrscheinlichkeit, 
                gezogen zu werden (1 zu 13.983.816). Es gibt keine "glücklicheren" oder "unglücklicheren" Zahlen.
              </p>
            </div>
          )}

          {activeTab === 'tips' && (
            <div>
              <h5 className="card-title text-white mb-3">Tipps für Lottospieler</h5>
              <div className="d-flex flex-column gap-3">
                <div className="card bg-dark bg-opacity-25 border-start border-warning border-4">
                  <div className="card-body">
                    <h6 className="text-warning mb-2">🎲 Zufälligkeit ist wichtig</h6>
                    <p className="text-white-50 mb-0">
                      Verwenden Sie zufällige Zahlen statt Geburtsdaten oder anderen persönlichen Zahlen. 
                      Dies erhöht zwar nicht Ihre Gewinnchancen, verhindert aber, dass Sie Ihre Gewinne mit anderen teilen müssen.
                    </p>
                  </div>
                </div>
                <div className="card bg-dark bg-opacity-25 border-start border-warning border-4">
                  <div className="card-body">
                    <h6 className="text-warning mb-2">📊 Zahlenverteilung</h6>
                    <p className="text-white-50 mb-0">
                      Eine gute Mischung aus hohen und niedrigen Zahlen ist empfehlenswert. 
                      Vermeiden Sie es, alle Zahlen aus einem engen Bereich zu wählen.
                    </p>
                  </div>
                </div>
                <div className="card bg-dark bg-opacity-25 border-start border-warning border-4">
                  <div className="card-body">
                    <h6 className="text-warning mb-2">💰 Verantwortungsvoll spielen</h6>
                    <p className="text-white-50 mb-0">
                      Lotto sollte als Unterhaltung betrachtet werden. Setzen Sie nur Geld ein, 
                      das Sie sich leisten können zu verlieren. Die Gewinnchancen sind sehr gering.
                    </p>
                  </div>
                </div>
                <div className="card bg-dark bg-opacity-25 border-start border-warning border-4">
                  <div className="card-body">
                    <h6 className="text-warning mb-2">📅 Regelmäßigkeit</h6>
                    <p className="text-white-50 mb-0">
                      Wenn Sie regelmäßig spielen, können Sie Ihre Zahlen im Verlauf speichern 
                      und so den Überblick behalten.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'faq' && (
            <div>
              <h5 className="card-title text-white mb-3">Häufig gestellte Fragen</h5>
              <div className="accordion" id="faqAccordion">
                {faqItems.map((item, index) => (
                  <div key={index} className="accordion-item bg-dark bg-opacity-25 border border-light border-opacity-25">
                    <h2 className="accordion-header" id={`heading${index}`}>
                      <button
                        className={`accordion-button ${openFaq === index ? '' : 'collapsed'} bg-dark bg-opacity-50 text-white`}
                        type="button"
                        onClick={() => toggleFaq(index)}
                        aria-expanded={openFaq === index}
                        aria-controls={`collapse${index}`}
                      >
                        {item.question}
                      </button>
                    </h2>
                    <div
                      id={`collapse${index}`}
                      className={`accordion-collapse collapse ${openFaq === index ? 'show' : ''}`}
                      aria-labelledby={`heading${index}`}
                    >
                      <div className="accordion-body text-white-50">
                        {item.answer}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InfoSection;
